import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { StyledText, Button } from "../../../../components/common";
import { NewBackButton, NoticeIcon } from "../../../../components/svgs";
import EventSurveyModal from "../components/EventSurveyModal";
import { surveys } from "../components/surveys";
import { useTheme } from "../../../../hooks";
import SurveyAlreadyAnsweredModal from "../components/SurveyAlreadyAnsweredModal";

const EventSurveyHome = () => {
  const history = useHistory();
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSurveyAnswered, setIsSurveyAnswered] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openIsSurveyAnswered = (survey) => {
    setSelectedSurvey(survey);
    setIsSurveyAnswered(true);
  };

  const closeIsSurveyAnswered = () => setIsSurveyAnswered(false);

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  const goToPointRedemption = () => {
    history.push("/event_survey/point-redemption");
  };

  return (
    <>
      <MainHolder>
        <Children>
          <Wrapper>
            <HeaderContainer>
              <BackButtonContainer onClick={goToHome}>
                <NewBackButton />
              </BackButtonContainer>
              <StyledText>Take Survey</StyledText>
              <NoticeIcon
                fill="black"
                style={{ zIndex: 100, marginRight: 15 }}
                onClick={openModal}
              />
            </HeaderContainer>

            <SurveyListContainer>
              {surveys.map((survey, index) => (
                <SurveyCard
                  key={index}
                  survey={survey}
                  isAnswered={survey.isAnswered}
                  onSurveyClick={
                    survey.isAnswered
                      ? () => openIsSurveyAnswered(survey)
                      : () => history.push(`/event_survey${survey.link}`)
                  }
                />
              ))}
            </SurveyListContainer>

            <ButtonContainer>
              <Button
                style={{ backgroundColor: background, width: "100%" }}
                onClick={goToPointRedemption}
              >
                <StyledText color="white">Redeem points</StyledText>
              </Button>
            </ButtonContainer>
          </Wrapper>
        </Children>
      </MainHolder>
      <EventSurveyModal isOpen={isModalOpen} onClose={closeModal} />
      <SurveyAlreadyAnsweredModal
        isOpen={isSurveyAnswered}
        onClose={closeIsSurveyAnswered}
        survey={selectedSurvey}
      />
    </>
  );
};

export default EventSurveyHome;

const SurveyCard = ({ survey, isAnswered, onSurveyClick }) => {
  return (
    <StyledBox onClick={onSurveyClick}>
      <div>
        <StyledText style={{ margin: 0 }}>{survey.surveyName}</StyledText>
        <StyledDescription>{survey.description}</StyledDescription>
        {/* {isAnswered && <StyledText color="red">(Already Answered)</StyledText>} */}
      </div>
    </StyledBox>
  );
};

// Styled Components

const Wrapper = styled.div`
  height: 100%;
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
`;

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  background-color: #fff;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin: 50px 0;
`;

const SurveyListContainer = styled.div`
  margin-top: 10%;
  width: 100%;
`;

const StyledBox = styled.div`
  display: flex;
  flex-direction: row;
  background-color: white;
  border-bottom: 1px solid gray;
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const StyledDescription = styled(StyledText)`
  margin: 0;
  color: #7f7f7f;
  font-family: "MTNRegular";
  font-size: 11px;
`;
